import moderation from '@spotim/fed-resources/resources/moderation';
import me from '@spotim/fed-resources/resources/me';
import { setNetworkIdInjectorValue } from '@spotim/fed-common';
import { DEFAULT_NETWORK_ID } from 'app/scripts/models/network-types';
import config from 'config/config';
import store from 'state';
import { setToken } from '../../../services/app-state';
import { setSuperAdminStatus } from '../../../../auth/authSlice';

export default async function (context, { spotId }, done) {
  setNetworkIdInjectorValue(DEFAULT_NETWORK_ID);

  try {
    store.dispatch(setSuperAdminStatus('loading'));
    let { body } = await me.fetchNetworkToken(DEFAULT_NETWORK_ID);

    setToken(body.token);
    const {
      body: { token_ticket: tokenTicket, spot_name: spotName }
    } = await moderation.setSuperOwner(spotId);
    let {
      body: { token, network_name: networkName }
    } = await me.fetchTokenByTicket(tokenTicket);

    store.dispatch(setSuperAdminStatus('success'));

    const url = `${config.api.basic}spot/${spotId}/moderation?name=${spotName}&token=${token}&network_name=${networkName}`;
    window.open(url);

    done();
  } catch (e) {
    context.dispatch('SET_SUPER_OWNER_FAILED');
    done();
  }
}
